import React from 'react';
import styles from './Paragraph.module.scss';
import cn from 'classnames';

interface ParagraphProps {
  small?: boolean;
}

export const Paragraph: React.FC<ParagraphProps> = ({ small, children }) => {
  return <p className={cn(styles['o-paragraph'], { [styles['o-paragraph--small']]: small })}>{children}</p>;
};
